import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import {
  ICancellationPreview,
  ICancellationRequest
} from "../../../interfaces/reservations/Cancellation.types";
import { submitCancellation } from "../../../services/Reservations.service";
import { resolveError } from "../../../utils/apiErrorMessage";
import { eur } from "../../../utils/eur";
import {
  buildCancellationSubmit,
  errorCode,
  isQuoteStale
} from "../../../utils/reservations/cancellation";
import { cancellationRefusalSentence } from "../../../utils/reservations/cancellationText";

const STALE = cancellationRefusalSentence({ code: "quote.stale", message: "" });

const doneMessage = (toCard: number, toWallet: number): string => {
  const parts = [
    toCard > 0 ? `Kartelë ${eur(toCard)}` : null,
    toWallet > 0 ? `Gjirafa Money ${eur(toWallet)}` : null
  ].filter(Boolean);
  return parts.length ? `Anulimi u krye. ${parts.join(" · ")}.` : "Anulimi u krye pa rimbursim.";
};

// Submits against the preview on screen. When the booking moved since that preview the server
// answers 409 quote.stale: the dialog re-asks for the figures and says why they changed, until
// the admin changes the selection.
const useSubmitCancellation = (
  onDone: () => void,
  reloadPreview: () => void,
  selectionKey: string
) => {
  const [submitting, setSubmitting] = useState(false);
  const [staleNotice, setStaleNotice] = useState<string | null>(null);

  useEffect(() => setStaleNotice(null), [selectionKey]);

  const submit = async (
    request: ICancellationRequest,
    preview: ICancellationPreview,
    payoutNow: boolean
  ) => {
    setSubmitting(true);
    try {
      const { data } = await submitCancellation(buildCancellationSubmit(request, preview, payoutNow));
      toast.success(doneMessage(data.toCard, data.toWallet));
      onDone();
    } catch (err) {
      if (isQuoteStale(err)) {
        setStaleNotice(STALE);
        reloadPreview();
      } else {
        const message = resolveError(err, "Ndodhi një gabim gjatë anulimit.");
        toast.error(cancellationRefusalSentence({ code: errorCode(err) ?? "", message }));
      }
    } finally {
      setSubmitting(false);
    }
  };

  return { submitting, staleNotice, submit };
};

export default useSubmitCancellation;
